import { memberDisplayName, type OrgMember } from '@noconflict/contracts';
import { useTranslation } from 'react-i18next';
import { useTransferOwnership } from '../../../entities/member';
import { identityErrorMessage } from '../../../shared/api/identity-error';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog';
import { toast } from '../../../shared/ui/sonner';

/** Owner only (Q32): the other person becomes an owner, then the caller steps down to admin. */
export function TransferOwnershipDialog({
  org,
  currentUserId,
  member,
  onOpenChange,
}: {
  org: { id: string };
  currentUserId: string;
  /** The member to hand ownership to; null keeps the dialog closed. */
  member: OrgMember | null;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation('member');
  const transfer = useTransferOwnership(org.id);
  const name = member ? memberDisplayName(member) : '';
  return (
    <ConfirmDialog
      open={member !== null}
      onOpenChange={onOpenChange}
      title={t('transfer.title', { name })}
      description={t('transfer.body', { name })}
      confirmLabel={t('transfer.confirm')}
      cancelLabel={t('transfer.cancel')}
      variant="primary"
      errorMessage={identityErrorMessage}
      onConfirm={async () => {
        if (!member) return;
        await transfer.mutateAsync({ fromUserId: currentUserId, toUserId: member.user_id });
        toast.success(t('transfer.done'));
      }}
    />
  );
}
